/* eslint import/prefer-default-export: 0 */
export const productActions = {
  PRODUCTS_IS_LOADING: 'PRODUCTS_IS_LOADING',
  PRODUCTS_ERROR: 'PRODUCTS_ERROR',
  PRODUCTS_RESET: 'PRODUCTS_RESET',
  PRODUCTS_NEW: 'PRODUCTS_NEW',
  PRODUCTS: 'PRODUCTS',
  SELECT_PRODUCT: 'SELECT_PRODUCT',
  PRODUCT_SUCCESS: 'PRODUCT_SUCCESS',
  SELECT_PRODUCT_RESET: 'SELECT_PRODUCT_RESET',
  PRODUCT_POSTCREATE: 'PRODUCT_POSTCREATE',
  PRODUCT_HISTORY: 'PRODUCT_HISTORY',
  PRODUCT_EVIDENCE: 'PRODUCT_EVIDENCE'
};
/* eslint import/prefer-default-export: 0 */
export const productSingleActions = {
  PRODUCT_SINGLE_IS_LOADING: 'PRODUCT_SINGLE_IS_LOADING',
  PRODUCT_SINGLE_ERROR: 'PRODUCT_SINGLE_ERROR',
  PRODUCT_SINGLE_RESET: 'PRODUCT_SINGLE_RESET',
  PRODUCT_SINGLE_NEW: 'PRODUCT_SINGLE_NEW',
  PRODUCT_SINGLE: 'PRODUCT_SINGLE'
};

export const productTagActions = {
  PRODUCT_TAG_IS_LOADING: 'PRODUCT_TAG_IS_LOADING',
  PRODUCT_TAG: 'PRODUCT_TAG',
  PRODUCT_TAG_ERROR: 'PRODUCT_TAG_ERROR',
  PRODUCT_INFORMATION_ERROR: 'PRODUCT_INFORMATION_ERROR',
  PRODUCT_INFORMATION: 'PRODUCT_INFORMATION'
};

export const userActions = {
  USERS_IS_LOADING: 'USERS_IS_LOADING',
  USERS_ERROR: 'USERS_ERROR',
  USERS_RESET: 'USERS_RESET',
  USERS_NEW: 'USERS_NEW',
  USERS_DRIVER_SIGNED_URL: 'USERS_DRIVER_SIGNED_URL',
  USERS: 'USERS'
};

export const reservationActions = {
  RESERVATIONS_IS_LOADING: 'RESERVATIONS_IS_LOADING',
  RESERVATIONS_ERROR: 'RESERVATIONS_ERROR',
  RESERVATIONS_RESET: 'RESERVATIONS_RESET',
  RESERVATIONS_NEW: 'RESERVATIONS_NEW',
  RESERVATIONS: 'RESERVATIONS'
};

export const groupActions = {
  GROUP_IS_LOADING: 'GROUP_IS_LOADING',
  GROUP_ERROR: 'GROUP_ERROR',
  GROUP_SUCCESS: 'GROUP_SUCCESS',
  GROUP_RESET: 'GROUP_RESET',
  SELECT_GROUP_RESET: 'SELECT_GROUP_RESET',
  GROUP: 'GROUP',
  GROUP_UPDATED: 'GROUP_UPDATED',
  GROUP_PDF: 'GROUP_PDF',
  GROUP_JOIN: 'GROUP_JOIN'
};

export const paymentActions = {
  PAYMENT_IS_LOADING: 'PAYMENT_IS_LOADING',
  PAYMENT_ERROR: 'PAYMENT_ERROR',
  PAYMENT_SUCCESS: 'PAYMENT_SUCCESS',
  MASSIVE_PAYMENT_SUCCESS: 'MASSIVE_PAYMENT_SUCCESS',
  MASSIVE_PAYMENT_ERROR: 'MASSIVE_PAYMENT_ERROR',
  PAYMENT_RESET: 'PAYMENT_RESET',
  SELECT_PAYMENT_RESET: 'SELECT_PAYMENT_RESET',
  PAYMENT: 'PAYMENT',
  PAYMENT_UPDATED: 'PAYMENT_UPDATED',
  PAYMENT_PDF: 'PAYMENT_PDF'
};

export const groupedPaymentActions = {
  GROUPED_PAYMENT_IS_LOADING: 'GROUPED_PAYMENT_IS_LOADING',
  GROUPED_PAYMENT_ERROR: 'GROUPED_PAYMENT_ERROR',
  GROUPED_PAYMENT: 'GROUPED_PAYMENT'
};

export const clientActions = {
  CLIENTS_IS_LOADING: 'CLIENTS_IS_LOADING',
  CLIENTS_ERROR: 'CLIENTS_ERROR',
  CLIENTS_RESET: 'CLIENTS_RESET',
  CLIENTS_NEW: 'CLIENTS_NEW',
  CLIENTS: 'CLIENTS'
};

export const orderActions = {
  ORDERS_IS_LOADING: 'ORDERS_IS_LOADING',
  ORDERS_ERROR: 'ORDERS_ERROR',
  ORDERS_RESET: 'ORDERS_RESET',
  ORDERS_NEW: 'ORDERS_NEW',
  ORDERS: 'ORDERS'
};

export const reverseOrderActions = {
  REVERSE_ORDERS_IS_LOADING: 'REVERSE_ORDERS_IS_LOADING',
  REVERSE_ORDERS_ERROR: 'REVERSE_ORDERS_ERROR',
  REVERSE_ORDERS_RESET: 'REVERSE_ORDERS_RESET',
  REVERSE_ORDERS_NEW: 'REVERSE_ORDERS_NEW',
  REVERSE_ORDERS: 'REVERSE_ORDERS'
};

export const travelActions = {
  TRAVELS_IS_LOADING: 'TRAVELS_IS_LOADING',
  TRAVELS_ERROR: 'TRAVELS_ERROR',
  TRAVELS_RESET: 'TRAVELS_RESET',
  TRAVELS_NEW: 'TRAVELS_NEW',
  TRAVELS: 'TRAVELS'
};

export const locationActions = {
  LOCATIONS_IS_LOADING: 'LOCATIONS_IS_LOADING',
  LOCATIONS_ERROR: 'LOCATIONS_ERROR',
  LOCATIONS_RESET: 'LOCATIONS_RESET',
  LOCATIONS_NEW: 'LOCATIONS_NEW',
  LOCATIONS_UPDATED: 'LOCATIONS_UPDATED',
  LOCATIONS: 'LOCATIONS'
};

export const routingActions = {
  ROUTING_IS_LOADING: 'ROUTING_IS_LOADING',
  ROUTING_ERROR: 'ROUTING_ERROR',
  ROUTING: 'ROUTING',
  ROUTING_NEW: 'ROUTING_NEW'
};

export const routingDetailActions = {
  ROUTING_DETAIL_IS_LOADING: 'ROUTING_DETAIL_IS_LOADING',
  ROUTING_DETAIL_ERROR: 'ROUTING_DETAIL_ERROR',
  ROUTING_DETAIL: 'ROUTING_DETAIL'
};

export const notificationActions = {
  NOTIFICATIONS_IS_LOADING: 'NOTIFICATIONS_IS_LOADING',
  NOTIFICATIONS_ERROR: 'NOTIFICATIONS_ERROR',
  NOTIFICATIONS_RESET: 'NOTIFICATIONS_RESET',
  NOTIFICATIONS_NEW: 'NOTIFICATIONS_NEW',
  NOTIFICATIONS_UPDATED: 'NOTIFICATIONS_UPDATED',
  NOTIFICATIONS: 'NOTIFICATIONS'
};

export const contractActions = {
  CONTRACTS_IS_LOADING: 'CONTRACTS_IS_LOADING',
  CONTRACTS_ERROR: 'CONTRACTS_ERROR',
  CONTRACTS: 'CONTRACTS'
};

export const countryActions = {
  COUNTRIES_IS_LOADING: 'COUNTRIES_IS_LOADING',
  COUNTRIES_ERROR: 'COUNTRIES_ERROR',
  COUNTRIES_RESET: 'COUNTRIES_RESET',
  COUNTRIES_NEW: 'COUNTRIES_NEW',
  COUNTRIES: 'COUNTRIES'
};

export const labelAddressActions = {
  LABEL_ADDRESS_IS_LOADING: 'LABEL_ADDRESS_IS_LOADING',
  LABEL_ADDRESS_ERROR: 'LABEL_ADDRESS_ERROR',
  LABEL_ADDRESS_RESET: 'LABEL_ADDRESS_RESET',
  LABEL_ADDRESS_NEW: 'LABEL_ADDRESS_NEW',
  LABEL_ADDRESS: 'LABEL_ADDRESS'
};

export const liveTrackingActions = {
  LIVE_TRACKING_IS_LOADING: 'LIVE_TRACKING_IS_LOADING',
  LIVE_TRACKING_ERROR: 'LIVE_TRACKING_ERROR',
  LIVE_TRACKING_RESET: 'LIVE_TRACKING_RESET',
  LIVE_TRACKING_NEW: 'LIVE_TRACKING_NEW',
  LIVE_TRACKING: 'LIVE_TRACKING'
};

export const incidentsActions = {
  INCIDENTS_IS_LOADING: 'INCIDENTS_IS_LOADING',
  INCIDENTS_ERROR: 'INCIDENTS_ERROR',
  INCIDENTS_RESET: 'INCIDENTS_RESET',
  INCIDENTS_NEW: 'INCIDENTS_NEW',
  INCIDENTS_DRIVER_SIGNED_URL: 'INCIDENTS_DRIVER_SIGNED_URL',
  INCIDENTS: 'INCIDENTS'
};

export const paymentsDeliveryActions = {
  PAYMENTS_DELIVERY_IS_LOADING: 'PAYMENTS_DELIVERY_IS_LOADING',
  PAYMENTS_DELIVERY_ERROR: 'PAYMENTS_DELIVERY_ERROR',
  PAYMENTS_DELIVERY_RESET: 'PAYMENTS_DELIVERY_RESET',
  PAYMENTS_DELIVERY_NEW: 'PAYMENTS_DELIVERY_NEW',
  PAYMENTS_DELIVERY: 'PAYMENTS_DELIVERY'
};

export const auditProductActions = {
  SCAN_PRODUCT_AUDIT_IS_LOADING: 'PRODUCT_AUDIT_IS_LOADING',
  SCAN_PRODUCT_AUDIT_ERROR: 'PRODUCT_AUDIT_ERROR',
  SCAN_PRODUCT_AUDIT_RESET: 'PRODUCT_AUDIT_RESET',
  SCAN_PRODUCT_AUDIT_NEW: 'PRODUCT_AUDIT_NEW',
  SCAN_PRODUCT_AUDIT: 'PRODUCT_AUDIT'
};

export const auditGroupActions = {
  SCAN_GROUP_AUDIT_IS_LOADING: 'GROUP_AUDIT_IS_LOADING',
  SCAN_GROUP_AUDIT_ERROR: 'GROUP_AUDIT_ERROR',
  SCAN_GROUP_AUDIT_RESET: 'GROUP_AUDIT_RESET',
  SCAN_GROUP_AUDIT_NEW: 'GROUP_AUDIT_NEW',
  SCAN_GROUP_AUDIT: 'GROUP_AUDIT'
};
export const resetAuditGroupActions = {
  RESET_GROUP_AUDIT_IS_LOADING: 'RESET_GROUP_AUDIT_IS_LOADING',
  RESET_GROUP_AUDIT_ERROR: 'GROUP_AUDIT_ERROR',
  RESET_GROUP_AUDIT_RESET: 'GROUP_AUDIT_RESET',
  RESET_GROUP_AUDIT_NEW: 'RESET_GROUP_AUDIT_NEW',
  RESET_GROUP_AUDIT: 'RESET_GROUP_AUDIT'
};

export const resourcesDriverUserActions = {
  RESOURCES_DRIVER_USER_IS_LOADING: 'RESOURCES_DRIVER_USER_IS_LOADING',
  RESOURCES_DRIVER_USER_ERROR: 'RESOURCES_DRIVER_USER_ERROR',
  RESOURCES_DRIVER_USER: 'RESOURCES_DRIVER_USER'
};
